export default "__VITE_ASSET__sbJoNJgp__"